import styles from "../../../pages/ordermanager/PurchaseOrder.module.css";

const PurchaseItemList = ({ mode, index, item }) => {
  return (
    <>
      <li
        className={`${styles.p_table_row} ${
          mode ? styles.p_table_row_dark : ""
        }`}
      >
        <div className={styles.entry_2}> {index + 1} </div>
        <div className={styles.entry_2}>{item.itemNo}</div>
        <div className={styles.entry_2}> {item.product_name} </div>
        <div className={styles.entry_2}>{item.qty}</div>
        <div className={styles.entry_2}> {item.unit}</div>
        <div className={styles.entry_2}> {item.price}</div>
        <div className={styles.entry_2}> {item.price * item.qty}</div>
      </li>
    </>
  );
};

export default PurchaseItemList;